var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (sale_registrations, undefined) {
if ( sale_registrations)
{
// iterate sale_registrations
;(function(){
  var $$obj = sale_registrations;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var registration = $$obj[$index];

var sale = registration.sale
if (!( sale.is_closed))
{
buf.push("<div class=\"settings-auction-registration\">");
if ( sale.profile && sale.profile.icon)
{
buf.push("<a" + (jade.attr("href", sale.href, true, true)) + " class=\"settings-auction-registration___icon\"><img" + (jade.attr("src", sale.profile.icon.url, true, true)) + "></a>");
}
buf.push("<div class=\"settings-auction-registration___metadata\"><a" + (jade.attr("href", sale.href, true, true)) + "><div class=\"settings-auction-registration___metadata__name\">" + (jade.escape(null == (jade_interp = sale.name) ? "" : jade_interp)) + "</div><div class=\"settings-auction-registration___metadata__date\">" + (jade.escape(null == (jade_interp = sale.start_at) ? "" : jade_interp)) + "</div></a></div><div class=\"settings-auction-registration___button\">");
if ( registration.is_registered)
{
buf.push("<a" + (jade.attr("href", sale.href, true, true)) + " class=\"avant-garde-button-white is-success\">Approved</a>");
}
else
{
buf.push("<a" + (jade.attr("href", '/auction-registration/' + (sale.id) + '', true, true)) + " class=\"avant-garde-button-black\">Register</a>");
}
buf.push("</div></div>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var registration = $$obj[$index];

var sale = registration.sale
if (!( sale.is_closed))
{
buf.push("<div class=\"settings-auction-registration\">");
if ( sale.profile && sale.profile.icon)
{
buf.push("<a" + (jade.attr("href", sale.href, true, true)) + " class=\"settings-auction-registration___icon\"><img" + (jade.attr("src", sale.profile.icon.url, true, true)) + "></a>");
}
buf.push("<div class=\"settings-auction-registration___metadata\"><a" + (jade.attr("href", sale.href, true, true)) + "><div class=\"settings-auction-registration___metadata__name\">" + (jade.escape(null == (jade_interp = sale.name) ? "" : jade_interp)) + "</div><div class=\"settings-auction-registration___metadata__date\">" + (jade.escape(null == (jade_interp = sale.start_at) ? "" : jade_interp)) + "</div></a></div><div class=\"settings-auction-registration___button\">");
if ( registration.is_registered)
{
buf.push("<a" + (jade.attr("href", sale.href, true, true)) + " class=\"avant-garde-button-white is-success\">Approved</a>");
}
else
{
buf.push("<a" + (jade.attr("href", '/auction-registration/' + (sale.id) + '', true, true)) + " class=\"avant-garde-button-black\">Register</a>");
}
buf.push("</div></div>");
}
    }

  }
}).call(this);

}
else
{
buf.push("Nothing yet.");
}}.call(this,"sale_registrations" in locals_for_with?locals_for_with.sale_registrations:typeof sale_registrations!=="undefined"?sale_registrations:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;